<div *ngIf="modalArguments" data-test-id="modal-default" class="modal-window">
  <div class="modal-header">
    <h4 class="modal-title" data-test-id="modal-title">
      {{ modalArguments.title | translate }}
    </h4>
    <button
      type="button"
      class="unstyled-button"
      aria-label="Close"
      data-test-id="modal-btn-dismiss"
      (click)="onDismiss()"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </div>
  <div class="modal-body">
    <div class="input-container" data-test-id="wrap-conversation-edit">
      <input
        data-test-id="conversation-title"
        [formControl]="conversationTitle"
        [ngClass]="{
          'form-control': true,
          'is-invalid': conversationTitle.invalid && (conversationTitle.dirty || conversationTitle.touched)
        }"
        type="search"
        [placeholder]="modalArguments.description"
        appTrimOnBlur
        #inputField
      />
      <ng-container *ngIf="conversationTitle.value?.length > 0">
        <button
          type="button"
          [attr.data-test-id]="'clear-button-edit-conversation-title-input'"
          class="btn btn-link clear-button"
          [style.right]="conversationTitle.errors ? '40px' : '10px'"
          (click)="clearInput(inputField)"
        >
          <svg-icon src="assets/icons/icon-cross.svg" class="icon-reset"></svg-icon>
        </button>
      </ng-container>
    </div>
    <div class="d-flex align-items-center mt-1">
      <small class="text-danger" data-test-id="error-message">
        <!-- Display error message for max length -->
        <ng-container *ngIf="conversationTitle.errors?.['maxlength']">
          {{ 'TITLE_MAX_LENGTH_ERROR' | translate: { maxLength: maxLength } }}
        </ng-container>
        <!-- Display error message for required field -->
        <ng-container *ngIf="conversationTitle.errors?.['required']">
          {{ 'TITLE_REQUIRED_ERROR' | translate }}
        </ng-container>
      </small>

      <app-counter
        class="ms-auto"
        [maxLength]="maxLength"
        [dataTestId]="'edit-title-counter'"
        [isFieldInvalid]="conversationTitle.errors?.['maxlength'] || conversationTitle.errors?.['required']"
        [valueLength]="conversationTitle.value?.length"
      >
      </app-counter>
    </div>
  </div>
  <div class="modal-footer" data-test-id="modal-footer">
    <button
      *ngFor="let button of modalArguments.buttons; index as i"
      [attr.type]="button.type || 'button'"
      class="btn"
      [disabled]="submitButton === button.action && !isValid"
      [ngClass]="button.class"
      (click)="actionsHandler(button.action)"
      [attr.data-test-id]="'modal-btn-' + i"
    >
      {{ button.text | translate }}
    </button>
  </div>
</div>
